export default __webpack_public_path__ + "static/media/icon-twitter.2384d95a.svg";